module.exports = __webpack_public_path__ + "static/sport/bgi-pc.c64639e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport3/bgi-pc.jpg
// module id = T8Oo
// module chunks = 0